<template>
    <div class="bg-white rounded-2xl border border-gray-200 overflow-hidden">
        <div class="px-4 pt-4 pb-2">
            <p class="text-lg font-bold text-slate-900">Travaux réalisés</p>
            <p class="text-sm text-slate-500 mt-0.5">Sélectionnez toutes les opérations effectuées.</p>
        </div>

        <div class="px-4 pb-4">

            <!-- Vide -->
            <div v-if="travauxList.length === 0" class="flex flex-col items-center py-8 text-slate-400">
                <svg class="w-10 h-10 mb-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"/>
                </svg>
                <p class="text-sm">Aucun travail disponible</p>
            </div>

            <!-- Liste -->
            <div v-else class="space-y-3 mt-2">
                <button
                    v-for="travaux in travauxList"
                    :key="travaux.id"
                    class="w-full flex items-center gap-3 px-3 py-4 rounded-xl border text-left transition-colors"
                    :class="isChecked(travaux.id)
                        ? 'bg-blue-50 border-blue-300'
                        : 'bg-gray-50 border-gray-200 hover:bg-gray-100'"
                    @click="toggle(travaux)"
                >
                    <div
                        class="w-5 h-5 rounded-md border-2 flex items-center justify-center shrink-0 transition-colors"
                        :class="isChecked(travaux.id) ? 'bg-blue-600 border-blue-600' : 'border-gray-300'"
                    >
                        <svg v-if="isChecked(travaux.id)" class="w-3 h-3 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                            <path d="M20 6L9 17l-5-5" stroke-linecap="round"/>
                        </svg>
                    </div>
                    <span
                        class="text-sm font-medium flex-1"
                        :class="isChecked(travaux.id) ? 'text-blue-800' : 'text-slate-700'"
                    >
                        {{ travaux.libelle }}
                    </span>
                    <span v-if="travaux.manipulation_fluide" class="text-xs font-semibold text-blue-500 bg-blue-50 border border-blue-200 px-2 py-0.5 rounded-full shrink-0">
                        Fluide
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StepTravaux',
    inject: ['wm'],

    data() {
        return {
            travauxList: []
        }
    },

    computed: {
        selected() { return this.wm.formData.typeInterventionDetails; },
        selectedCount() { return this.selected.length; },
    },

    methods: {
        isChecked(id) { return this.selected.some((t) => t.id === id); },

        toggle(travaux) {
            const exists = this.isChecked(travaux.id);
            this.wm.updateFormData({
                typeInterventionDetails: exists
                    ? this.selected.filter((t) => t.id !== travaux.id)
                    : [...this.selected, travaux],
            });
        },
    },

    mounted() {
        this.travauxList = this.wm.intervention.travaux || [];
    }
};
</script>
